import en from './en'
import zh from './zh'
import hk from './hk'
import pt from './pt'
import es from './es'
import tr from './tr'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import hkLocale from 'element-ui/lib/locale/lang/zh-TW'
import ptLocale from 'element-ui/lib/locale/lang/pt'
import esLocale from 'element-ui/lib/locale/lang/es'
import trLocale from 'element-ui/lib/locale/lang/tr-TR'

const messages = {
  en: {
    ...en,
    ...enLocale
  },
  zh: {
    ...zh,
    ...zhLocale
  },
  hk: {
    ...hk,
    ...hkLocale
  },
  pt: {
    ...pt,
    ...ptLocale
  },
  es: {
    ...es,
    ...esLocale
  },
  tr: {
    ...tr,
    ...trLocale
  }
}
export default messages